import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ArtifactDeltaButtonProps } from "@/types";
import { ListItem } from "@/components/common";


/**
 * Displays an artifact delta button.
 */
const __default__ = {
  name: "ArtifactDeltaButton",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    name: {},
    deltaType: {}
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ListItem), {
    clickable: "",
    title: props.name,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click')))
  }, null, 8, ["title"]))
}
}

})